<template>
  <nav v-if="socials.length > 0">
    <ul>
      <li v-for="social in socials">
        <a :href="social.value" target="_blank" rel="noreferrer nofollow noopener">
          <i class="fab" :class="`fa-${social.type.id}`"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      socials: 'store/activeCitySocials',
    }),
  },
}
</script>
